import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TeacherProfile from "./pages/TeacherProfile";
import StudentProfile from "./pages/StudentProfile";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AddCourse from "./pages/AddCourse";
// import CourseDetails from "./pages/CourseDetails"; 
import Chat from "./pages/Chat";
import ChatBox from "./pages/ChatBox"; 
import AddStudentCourse from "./pages/AddStudentCourse";  
import ErrorDisplay from "./pages/ErrorDisplay";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/signup/:role" element={<Signup />} />
        <Route path="/profile/teacher" element={<TeacherProfile />} />
        <Route path="/profile/student" element={<StudentProfile />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/add-course" element={<AddCourse />} />
        <Route path="/chat" element={<ChatBox/>} />
        <Route path="/chatapp" element={<Chat />} />
        <Route path="/addStudentCourse" element={<AddStudentCourse />} /> 
        <Route path="/customError" element={<ErrorDisplay />}/>
      </Routes>
    </Router>
  );
};

export default App;